import type { ReactNode } from 'react'

import { EmptyState, Panel } from '../../ui/primitives'

/**
 * Активные лоты: текущая ставка и время до закрытия.
 *
 * Экран-заготовка: разметка и место под данные есть, загрузка из API
 * появится вместе с наполнением каталога.
 */
export function AuctionsScreen(): ReactNode {
  return (
    <section>
      <h1>Аукцион</h1>
      <Panel>
        <EmptyState text="Пока пусто" />
      </Panel>
    </section>
  )
}
